var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c(
          "div",
          {
            staticClass: "card shadow-sm",
            staticStyle: { border: "2px solid black" }
          },
          [
            _c("div", { staticClass: "card-body p-3" }, [
              _c("h3", { staticClass: "mt-2 text-center oswald" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      _vm.$t("pages.locker.my_aform.tranings_completed", {
                        count: _vm.total
                      })
                    ) +
                    "\n                        "
                ),
                _c("i", {
                  staticClass: "mdi mdi-check-decagram mdi-36px float-right"
                })
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c(
          "div",
          {
            staticClass: "card shadow-sm",
            staticStyle: { border: "2px solid black" }
          },
          [
            _c("div", { staticClass: "card-body p-3" }, [
              _c("h3", { staticClass: "mt-2 text-center oswald" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      _vm.$t(
                        "pages.locker.my_aform.tranings_completed_this_month",
                        {
                          count: _vm.current_month,
                          dateStart: _vm
                            .$date(_vm.dateFrom)
                            .format("DD.MM.YYYY"),
                          dateEnd: _vm.$date(_vm.dateTo).format("DD.MM.YYYY")
                        }
                      )
                    ) +
                    "\n                        "
                ),
                _c("i", {
                  staticClass: "mdi mdi-check-decagram mdi-36px float-right"
                })
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }